module.exports = __webpack_public_path__ + "img/zlindex1.89f3ebc2.png";